// extracted by mini-css-extract-plugin
module.exports = {"mutedGray":"#9b9b9b","slider":"style-module--slider--uCjYU","imageWrapper":"style-module--imageWrapper--2rZKZ","multiline":"style-module--multiline--2Hzel"};